import { Routes } from '@angular/router';
import { ManageProductComponent } from './manage-product/manage-product.component';
import { ProductsComponent } from './products/products.component';

export const ProductRoutingModule: Routes = [
	{ path: 'products', component: ProductsComponent },
	{ path: 'add-product', component: ManageProductComponent },
	{ path: 'edit-product/:id', component: ManageProductComponent },
];
